module.exports = __webpack_public_path__ + "img/gz.cb082a46.svg";